<template>
  <v-card class="mx-auto" tile :loading="laden">
    <v-system-bar color="indigo darken-2" dark>
      <v-spacer></v-spacer>
      <span></span>
    </v-system-bar>

    <v-toolbar color="indigo" dark>
      <v-toolbar-title>Gedicht - Deel 2</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="sheet = true">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <br />
      <v-container fluid>
        <p style="margin-left: 10px;">
          Goed gedaan, kwam je er snel op?<br />
          Zo ja, dat is top.<br />
          Want waarom doen we er nog niet even een raadseltje bij?<br />
          ’t is niet zo’n groot karwei.
        </p>
      </v-container>
    </v-layout>
    <div class="text-center">
      <v-bottom-sheet v-model="sheet" persistent>
        <v-sheet class="text-center">
          <div class="py-3">
            <img src="/Raadseltje.png" /><br />
            <b
              >Wat is het nummer van het vak waarin de auto geparkeerd staat?</b
            >
            <br />
            <br />
            <p class="grey--text">
              Noem het antwoord hardop om door te
              <span @click="next">gaan</span>.
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    time: "",
    laden: false,
    sheet: false,
  }),
  methods: {
    next() {
      this.$router.push({ name: "Deel3" });
    },
  },
  computed: {},
  mounted() {
    let SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;

    recognition.lang = "nl";
    recognition.interimResults = true;

    recognition.addEventListener("result", (event) => {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.time = text.split(" ").pop();
      if (text.includes("arwei")) {
        this.sheet = true;
      }
      if (text.includes("87") && this.sheet == true) {
        this.$router.push({ name: "Deel3" });
      }
    });

    recognition.addEventListener("end", () => {
      if (this.$route.name == "Deel2") {
        recognition.start();
      }
    });
    recognition.start();
  },
};
</script>
